<div class="flex flex-col h-full w-full">
  <div class="top-panel flex flex-row p-4 justify-between">
    <span class="text-lg font-semibold">{{
      'pickup_location.warehouse' | translate
    }}</span>
    <button (click)="onClose()" dsw-small-icon-button="none" mat-icon-button>
      <mat-icon style="font-size: 16px; height: 16px; width: 16px">
        close
      </mat-icon>
    </button>
  </div>
  <div class="flex flex-row w-full grow overflow-hidden" cdkFocusInitial>
    <pickup-warehouse-detail class="w-full"></pickup-warehouse-detail>
  </div>
  <div class="bottom-panel flex flex-row p-4 gap-2 justify-end">
    <button dsw-primary-button dsw-small-button matRipple (click)="onClose()">
      <span>{{ 'common.close' | translate }}</span>
    </button>
  </div>
</div>
